
import React, { useState, useCallback } from 'react';
import Popover from '@material-ui/core/Popover';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import style from './style.module.css';

const usePopperContainerStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
    },
  }),
);

const PopperContainer = ({ children }: { children: React.ReactNode }) => {
  const classes = usePopperContainerStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isInContent, setIsInContent] = useState<boolean>(false)

  const handlePopoverOpen = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  }, [setAnchorEl]);

  const handleOnMouseLeavePopover = useCallback(() => {
    setIsInContent(false)
    handlePopoverClose()
  }, []);


  const handlePopoverClose = () => setAnchorEl(null)

  const open = Boolean(anchorEl) || isInContent;

  return (
    <div onMouseLeave={handlePopoverClose}>
      <div onMouseEnter={handlePopoverOpen} >
        <div className={style.ellipsis}>{children}</div>
      </div>
      <Popover
        className={style.translateX}
        onClick={(event) => event.stopPropagation()}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        >
          <div
            onMouseEnter={() => setIsInContent(true)}
            onMouseLeave={handleOnMouseLeavePopover}
          >{children}</div>
      </Popover>
    </div>
  )
}

export default PopperContainer